export default function megaMenu() {
    const toggle = document.getElementById('produtosToggle');
    const wrap = document.getElementById('megaMenuWrap');
    const panel = document.getElementById('megaPanel');
    const backdrop = document.getElementById('megaBackdrop');
    const viewCats = document.getElementById('megaViewCats');
    const viewItems = document.getElementById('megaViewItems');
    const filterBtns = document.querySelectorAll('.mega-filter-btn');
    const catCols = document.querySelectorAll('.mega-cat-col');
    const catCards = document.querySelectorAll('.mega-cat-card');
    const itemCols = document.querySelectorAll('.mega-item-col');
    const backBtn = document.getElementById('megaBackBtn');
    const itemsTitle = document.getElementById('megaItemsTitle');

    if (!toggle || !wrap) return;

    // Define CSS var com altura da navbar
    function updateNavbarHeight() {
        const nav = document.querySelector('#topo nav');
        if (nav) {
            document.documentElement.style.setProperty('--navbar-h', nav.offsetHeight + 'px');
        }
    }
    updateNavbarHeight();
    window.addEventListener('resize', updateNavbarHeight);

    function openMenu() {
        wrap.classList.add('open');
        toggle.classList.add('mega-open');
        document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
        wrap.classList.remove('open');
        toggle.classList.remove('mega-open');
        document.body.style.overflow = '';
        // Reseta para view de categorias após fechar
        setTimeout(showCatsView, 300);
    }

    function isMobile() {
        return window.innerWidth < 992;
    }

    toggle.addEventListener('click', function (e) {
        e.preventDefault();

        if (wrap.classList.contains('open')) {
            closeMenu();
            return;
        }

        // Em mobile: fecha o collapse instantaneamente (sem animação) antes de abrir
        if (isMobile()) {
            const navCollapse = document.getElementById('navbarNav');
            if (navCollapse && navCollapse.classList.contains('show')) {
                navCollapse.style.transition = 'none';
                navCollapse.style.height = '';
                navCollapse.classList.remove('show', 'collapsing');
                void navCollapse.offsetHeight; // força reflow para aplicar display:none
                navCollapse.style.transition = '';
                const toggler = document.querySelector('.navbar-toggler');
                if (toggler) {
                    toggler.setAttribute('aria-expanded', 'false');
                    toggler.classList.add('collapsed');
                }
            }
        }

        openMenu();
    });

    // Fecha ao clicar no backdrop
    backdrop.addEventListener('click', closeMenu);

    // Fecha com ESC
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && wrap.classList.contains('open')) {
            closeMenu();
        }
    });

    // Fecha ao clicar em outros links do nav
    document.querySelectorAll('#navbarNav .nav-link:not(#produtosToggle)').forEach(function (link) {
        link.addEventListener('click', function () {
            if (wrap.classList.contains('open')) closeMenu();
        });
    });

    // FILTRO DE CATEGORIAS
    function filterCategories(filter) {
        catCols.forEach(function (col) {
            const isExclusive = col.dataset.exclusive === '1';
            if (filter === 'exclusivos') {
                col.style.display = isExclusive ? '' : 'none';
            } else {
                col.style.display = !isExclusive ? '' : 'none';
            }
        });
    }

    filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            filterBtns.forEach(function (b) { b.classList.remove('active'); });
            this.classList.add('active');
            filterCategories(this.dataset.filter);
        });
    });

    // Aplica filtro inicial
    filterCategories('tradicionais');

    // CLIQUE NO CARD DE CATEGORIA → mostra itens
    catCards.forEach(function (card) {
        const verMaisBtn = card.querySelector('.btn-ver-mega');
        if (!verMaisBtn) return;

        verMaisBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            const catId = card.dataset.categoryId;
            const catTitle = card.dataset.categoryTitle;
            showItemsView(catId, catTitle);
        });
    });

    function showItemsView(catId, catTitle) {
        viewCats.classList.add('d-none');
        viewItems.classList.remove('d-none');
        if (itemsTitle) itemsTitle.textContent = catTitle;
        if (panel) panel.scrollTop = 0;

        itemCols.forEach(function (col) {
            col.style.display = col.dataset.catId === catId ? '' : 'none';
        });
    }

    function showCatsView() {
        viewCats.classList.remove('d-none');
        viewItems.classList.add('d-none');
        if (panel) panel.scrollTop = 0;
    }

    // BOTÃO VOLTAR
    if (backBtn) {
        backBtn.addEventListener('click', showCatsView);
    }

    // BOTÃO FECHAR (mobile)
    document.querySelectorAll('.mega-close-btn').forEach(function (btn) {
        btn.addEventListener('click', closeMenu);
    });

    // ── MOBILE OVERLAY ────────────────────────────────
    const mobileOverlay = document.getElementById('mobileOverlay');
    const mobileMenuToggle = document.getElementById('mobileMenuToggle');
    const mobileMenuClose = document.getElementById('mobileMenuClose');
    const mobileProdutosToggle = document.getElementById('mobileProdutosToggle');

    if (mobileOverlay && mobileMenuToggle) {
        function openMobileOverlay() {
            mobileOverlay.classList.add('open');
            document.body.style.overflow = 'hidden';
        }

        function closeMobileOverlay() {
            mobileOverlay.classList.remove('open');
            document.body.style.overflow = '';
        }

        mobileMenuToggle.addEventListener('click', openMobileOverlay);

        if (mobileMenuClose) {
            mobileMenuClose.addEventListener('click', closeMobileOverlay);
        }

        if (mobileProdutosToggle) {
            mobileProdutosToggle.addEventListener('click', function () {
                closeMobileOverlay();
                openMenu();
            });
        }

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && mobileOverlay.classList.contains('open')) {
                closeMobileOverlay();
            }
        });
    }
}
